import InviteList from "@/components/invites/InviteList";
import type { LayoutContext } from "@/lib/models";
import { InviteService, type Invite } from "@/services/InviteService";
import { User, UserService } from "@/services/UserService"
import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react"
import { useOutletContext } from "react-router";

const UserProfilePage: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const layoutContext = useOutletContext<LayoutContext | null>();
    const setPageName = layoutContext?.setPageName;
    const [copied, setCopied] = useState(false);
    const [invites, setInvites] = useState<Invite[]>([]);

    const handleRemoveInvite = async (invite: Invite) => {
        await InviteService.cancel(invite.id);
    }

    const copyToClipboard = async (text: string | null) => {
        if (!text) return;

        try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        
        // Reset icon after 2 seconds
        setTimeout(() => setCopied(false), 2000);
        } catch (err) {
        console.error('Failed to copy:', err);
        // Fallback for older browsers / React Native Web
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        }
    };    

    useEffect(() => {
        const initPage = async () => {
            const [invites, user]  = await Promise.all([
                InviteService.getActive(),
                UserService.getMe(),
                
            ]);
            const pageName = `${user.name} - Profile`;
            setUser(user);
            setInvites(invites);
            if (setPageName) {
                setPageName(pageName)
            } else {
                document.title = pageName;
            }
        }
        initPage()
    
    }, [setPageName])

    return (<div className="container mx-auto p-4">
        <h1>Profile</h1>
        {user && (
            <div>
                <p>Name: {user.name}</p>
                <p>Email: {user.email}</p>
                <div className="flex items-center gap-2">
                    <p>Code: <span className="font-mono font-medium">{user.inviteCode}</span></p>
                    
                    <button
                    onClick={() => copyToClipboard(user.inviteCode)}
                    className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all active:scale-95"
                    title="Copy code"
                    >
                    {copied ? (
                        <Check size={18} className="text-green-600" />
                    ) : (
                        <Copy size={18} />
                    )}
                    </button>
                </div>
            </div>
        )}
        <InviteList invites={invites} setInvites={setInvites} title="Pending Invites" instructions="Your pending invitations." showAcceptButton={true} onRemove={handleRemoveInvite} />
    </div>);
}

export default UserProfilePage;
